import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../utils/data-load-error/data-load-error";

export enum OrderAddNotAcceptableErrorType {
  INCONSISTENT_RIDE_TIMING = "INCONSISTENT_RIDE_TIMING",
  TIME_NOT_AVAILABLE = "TIME_NOT_AVAILABLE",
  TIMING_NOT_POSSIBLE = "TIMING_NOT_POSSIBLE",
  NO_VALID_CARGO_TAXI_CONTRACT = "NO_VALID_CARGO_TAXI_CONTRACT",
  PASSENGERS_DO_OVERLAP = "PASSENGERS_DO_OVERLAP",
}

export enum OrderAddUnprocessableEntityErrorType {
  TOO_LONG_RIDE = "TOO_LONG_RIDE",
  DEFAULT = "DEFAULT",
}

export type OrderAddDefaultError = DataLoadError<
  OrderAddUnprocessableEntityErrorType.DEFAULT,
  {}
>;

export type OrderAddUnprocessableEntityTooLongRideError = DataLoadError<
  OrderAddUnprocessableEntityErrorType.TOO_LONG_RIDE,
  {}
>;

export type OrderAddNotAcceptableInconsistentRideTimingError = DataLoadError<
  OrderAddNotAcceptableErrorType.INCONSISTENT_RIDE_TIMING,
  {}
>;

export type OrderAddNorAcceptableTimeNotAvailableError = DataLoadError<
  OrderAddNotAcceptableErrorType.TIME_NOT_AVAILABLE,
  {}
>;

export type OrderAddNotAcceptableTimingNotPossibleError = DataLoadError<
  OrderAddNotAcceptableErrorType.TIMING_NOT_POSSIBLE,
  {}
>;

export type OrderAddNotAcceptableNoValidCargoTaxiContract = DataLoadError<
  OrderAddNotAcceptableErrorType.NO_VALID_CARGO_TAXI_CONTRACT,
  {}
>;

export type OrderAddNotAcceptablePassengerDoOverlapError = DataLoadError<
  OrderAddNotAcceptableErrorType.PASSENGERS_DO_OVERLAP,
  {}
>;

export type OrderAddNotAcceptableError =
  | OrderAddNotAcceptableInconsistentRideTimingError
  | OrderAddNorAcceptableTimeNotAvailableError
  | OrderAddNotAcceptableTimingNotPossibleError
  | OrderAddNotAcceptableNoValidCargoTaxiContract
  | OrderAddNotAcceptablePassengerDoOverlapError;

export type OrderAddUnprocessableEntityError =
  | OrderAddUnprocessableEntityTooLongRideError
  | OrderAddDefaultError;

type OrderAddError =
  | DataLoadDefaultErrors
  | OrderAddNotAcceptableError
  | OrderAddUnprocessableEntityError;

export default OrderAddError;
